export default "__VITE_ASSET__Dmh3NIrd__"